<footer
  class="border-t border-white/5 bg-ink text-ink-foreground"
  [attr.aria-labelledby]="'footer-heading'"
>
  <h2 id="footer-heading" class="sr-only">{{ 'footer.heading' | transloco }}</h2>

  <div class="container mx-auto grid gap-12 px-6 py-16 md:grid-cols-12">
    <div class="md:col-span-4">
      <a
        [routerLink]="'/' | localizedRouterLink"
        class="inline-flex items-center text-white"
        [attr.aria-label]="'common.homeAriaLabel' | transloco"
      >
        <app-infogov-logo className="h-8" />
      </a>
      <p class="mt-5 max-w-xs text-[13px] leading-relaxed text-white/60">
        {{ 'footer.description' | transloco }}
      </p>
    </div>

    @for (section of sections; track section.titleKey) {
      <nav [attr.aria-label]="section.ariaLabelKey | transloco" class="md:col-span-2">
        <h3 class="mb-4 eyebrow-on-dark">{{ section.titleKey | transloco }}</h3>
        <ul class="space-y-2 text-[13px] text-white/75">
          @for (link of section.links; track link.labelKey) {
            <li>
              @if (link.external && link.path) {
                <a
                  [href]="link.path"
                  target="_blank"
                  rel="noreferrer"
                  class="footer-link inline-flex items-center gap-1"
                >
                  {{ link.labelKey | transloco }}
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="h-3 w-3"
                  >
                    <path d="M15 3h6v6" />
                    <path d="M10 14 21 3" />
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  </svg>
                </a>
              } @else if (link.path && !link.disabled) {
                <a [routerLink]="link.path | localizedRouterLink" class="footer-link">
                  {{ link.labelKey | transloco }}
                </a>
              } @else {
                <span aria-disabled="true" class="footer-link cursor-not-allowed opacity-45">
                  {{ link.labelKey | transloco }}
                </span>
              }
            </li>
          }
        </ul>
      </nav>
    }

    <div class="md:col-span-2">
      <h3 class="mb-4 eyebrow-on-dark">{{ 'footer.contact' | transloco }}</h3>
      <a
        href="mailto:dados@enap.gov.br"
        class="footer-link inline-flex items-center gap-1.5 text-[13px] text-white/75"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="h-3.5 w-3.5"
        >
          <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
          <rect x="2" y="4" width="20" height="16" rx="2" />
        </svg>
        dados@enap.gov.br
      </a>
    </div>
  </div>

  <div class="border-t border-white/[0.06]">
    <div
      class="container mx-auto flex flex-col items-center justify-between gap-2 px-6 py-6 text-[11.5px] text-white/40 md:flex-row"
    >
      <span class="tracking-wide">{{ 'footer.copyright' | transloco }}</span>
      <span class="tracking-wide">{{ 'footer.credits' | transloco }}</span>
    </div>
  </div>
</footer>
